import $ from 'jquery'
import { createApp } from '@app/adapters/create-app'

import SingleFileDirectUploader from '@app/shared/vue/components/direct-upload/single-file-direct-uploader'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='manual-ledger-upload-form']").each(function () {
    const $form = $(this)

    const uploader = $form
      .find("[data-behaviour='manual-ledger-upload-uploader']")
      .get(0)
    const data = $(uploader).data()

    const handleFileUploaded = ({ blob }) => {
      const $hiddenInput = $('<input>')
        .attr('type', 'hidden')
        .attr('name', data.paramsName)
        .val(blob.signed_id)

      $form.append($hiddenInput)
      $form.submit()
    }

    createApp(SingleFileDirectUploader, {
      accept: data.accept,
      onFileUploaded: handleFileUploaded,
      btnTitle: data.btnTitle,
      highlightAi: data.highlightAi,
    }).mount(uploader)
  })
})
